export const TRANSITIONS = {
  base: 240,

  /**
   * @see {@link https://docs.expo.dev/versions/latest/sdk/image/#transition Expo Image | Transition}
   */
  image: 120,
};
